import React from 'react';
import { Mail, Clock, User, CheckCircle } from 'lucide-react';

export default function EmailHistory({ history }) {
  if (!history || history.length === 0) return null;

  const sorted = [...history].sort((a, b) => new Date(b.sent_at) - new Date(a.sent_at));

  const formatDate = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="border-t pt-4" data-testid="email-history-section">
      <div className="flex items-center gap-2 mb-3">
        <Mail size={14} className="text-blue-600" />
        <p className="text-[10px] text-gray-400 uppercase tracking-widest font-semibold">
          Historique des envois ({history.length})
        </p>
      </div>
      <div className="space-y-2">
        {sorted.map((entry, i) => (
          <div key={`eh-${i}`} className="flex items-start gap-3 bg-blue-50/60 border border-blue-100 rounded-lg px-3 py-2.5" data-testid={`email-history-entry-${i}`}>
            <CheckCircle size={14} className="text-green-500 mt-0.5 shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="text-sm font-medium text-gray-900 truncate">{entry.recipient_email}</span>
                {entry.recipient_name && <span className="text-xs text-gray-500">({entry.recipient_name})</span>}
              </div>
              <div className="flex items-center gap-3 mt-0.5">
                <span className="flex items-center gap-1 text-xs text-gray-400">
                  <Clock size={10} /> {formatDate(entry.sent_at)}
                </span>
                <span className="flex items-center gap-1 text-xs text-gray-400">
                  <User size={10} /> {entry.sent_by || 'admin'}
                </span>
              </div>
              {entry.message && <p className="text-xs text-gray-500 mt-1 italic truncate">"{entry.message}"</p>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
